import dynamic from "next/dynamic";
import RegularHeaderConfig from "./regular-header-config";
import RegularHeaderAdvancedConfig from "./regular-header-advanced-config";
const RegularHeaderComponent = dynamic(()=>import("./regular-header-component"));
export default {
    RegularHeaderComponent,
    RegularHeaderConfig,
    RegularHeaderAdvancedConfig
};
